// Helpers. (Any state afected on this functions)
import _ from 'lodash';
import { dateFns, FilterQueryParams, getParamsOrDeleteNumber, getParamsOrDeleteString } from '.';

export const prepareFilter = (queryParams, filters, dates, dateQueryProp) => {
    const { dateFrom, dateTo } = dates;

    const newQueryParams = { ...queryParams };
    const newFilters = new FilterQueryParams();

    // Handle filter date range
    if (dateFrom && dateTo) {
        let startAt = dateFns.parse(dateFns.format(dateFrom, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');
        startAt = dateFns.format(startAt, 'y-MM-dd HH:mm:ss');

        let endAt = dateFns.parse(dateFns.format(dateTo, 'y-MM-dd 23:59:59'), 'y-MM-dd HH:mm:ss');
        endAt = dateFns.format(endAt, 'y-MM-dd HH:mm:ss');

        newFilters.between((dateQueryProp ?? 'created_at'), startAt, endAt);
    }

    _.forEach(filters, filter => {
        if (filter.property.description) {
            let valueToFilter = filter.property.type === 'select' ? filter.value?.id : filter.value;

            const operator = filter.property.operator;
            if (operator === 'like') valueToFilter = `*${valueToFilter}*`;
            if (operator === 'in') valueToFilter = filter.value;
            if (typeof filter.property.description === 'object') newFilters[operator](filter.property.description[valueToFilter], valueToFilter);
            newFilters[operator](filter.property.description, valueToFilter);
        }
    });

    // Delete or update sortOrder, sortField, pageNumber, pageSize
    const params = new URLSearchParams(window.location.search);
    params.get('sortOrder') && (newQueryParams.sortOrder = getParamsOrDeleteString(params, 'sortOrder'));
    params.get('sortField') && (newQueryParams.sortField = getParamsOrDeleteString(params, 'sortField'));
    params.get('pageNumber') && (newQueryParams.pageNumber = getParamsOrDeleteNumber(params, 'pageNumber'));
    params.get('pageSize') && (newQueryParams.pageSize = getParamsOrDeleteNumber(params, 'pageSize'));
    params.get('dateFrom') || params.delete('dateFrom');
    params.get('dateTo') || params.delete('dateTo');

    newQueryParams.filters = newFilters;
    return newQueryParams;
};
export const prepareAuditFilter = (queryParams, dates) => {
    const { dateFrom, dateTo } = dates;
    const newQueryParams = { ...queryParams };
    const newFilters = new FilterQueryParams();

    // Handle filter date range
    if (dateFrom && dateTo) {
        let startAt = dateFns.parse(dateFns.format(dateFrom, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');
        startAt = dateFns.format(startAt, 'y-MM-dd HH:mm:ss');

        let endAt = dateFns.parse(dateFns.format(dateTo, 'y-MM-dd 23:59:59'), 'y-MM-dd HH:mm:ss');
        endAt = dateFns.format(endAt, 'y-MM-dd HH:mm:ss');

        newFilters.between('created_at', startAt, endAt);
    }

    newQueryParams.filters = newFilters;
    return newQueryParams;
};

/**
 *
 * @param {*} typesToFilter is the original list
 * @param {*} filtersList is the list that we can't select again
 * @returns A list with filters availables
 */
export const excludingFilters = (typesToFilter, filtersList) => {
    const losIds = filtersList.map(filter => filter.property.id);
    return typesToFilter.filter((filter) => {
        return losIds.indexOf(filter.id) === -1;
    });
};
